import { useEmployeeIsNursingHomeAdminOrManager } from '@pflegenavi/frontend/nursing-home-context';

import { FeatureFlag } from '@pflegenavi/shared/api';
import { useFeatureFlagEnabled } from '@pflegenavi/frontend/feature-flags';
import { useEmployeeProfilePhoenix } from '@pflegenavi/frontend/api-nursing-home';
import { useEmployeeIsNursingHomeAdmin } from '@pflegenavi/frontend/nursing-home-context';

export function useCanSeeEmployeeList(): boolean {
  const { data: employeeProfile } = useEmployeeProfilePhoenix({});

  const isNursingHomeAdmin = useEmployeeIsNursingHomeAdmin();
  const isNursingHomeAdminOrManager = useEmployeeIsNursingHomeAdminOrManager();
  const employeeManagementFeatureFlagEnabled = useFeatureFlagEnabled(
    FeatureFlag.EmployeeManagement
  );

  return employeeProfile?.use_new_authorization
    ? isNursingHomeAdminOrManager
    : isNursingHomeAdmin && employeeManagementFeatureFlagEnabled;
}
